import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { ServiceCardsComponent } from "./service-cards/service-cards.component";


const routes: Routes = [{
    path: 'service-cards',
    canActivate: [
        AuthGuard
    ],
    children: [
        {
            path: '',
            component: ServiceCardsComponent
        }
    ]
}];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
    ],
    exports: [
        RouterModule,
    ]
})

export default class ServiceCardsRoutingModule {
}